import type { AccentHue } from "@repo/fika-design-system/color"
import { A } from "@solidjs/router"
import { createMemo, type JSXElement, type ParentProps, Show } from "solid-js"
import { Icon, type IconSize } from "@/designSystem/components/icon"
import { iconRecipe, linkRecipe } from "./card.css"

type Props = ParentProps & {
  href: string
  logo?: JSXElement
  hue: AccentHue
  expand?: boolean
  iconSize?: IconSize
  selected?: boolean
}

export function Card(props: Props) {
  const className = createMemo(() =>
    linkRecipe({
      hue: props.hue,
      expand: props.expand,
      selected: !!props.selected,
    }),
  )

  return (
    <Show
      when={!props.selected}
      fallback={
        <span class={className()}>
          <Content
            logo={props.logo}
            children={props.children}
            iconSize={props.iconSize}
            hue={props.hue}
          />
        </span>
      }
    >
      <A href={props.href} class={className()}>
        <Content
          logo={props.logo}
          children={props.children}
          iconSize={props.iconSize}
          hue={props.hue}
        />
      </A>
    </Show>
  )
}

function Content(
  props: {
    logo?: JSXElement
    iconSize?: IconSize
    hue: AccentHue
  } & ParentProps,
) {
  return (
    <>
      {props.logo}
      {props.children}
      <Icon
        size={props.iconSize ?? "24"}
        class={iconRecipe({ hue: props.hue })}
        name="arrow-right"
      />
    </>
  )
}
